export type BidTemplate = {
  key: string
  label: string
  json: string
}

export const BID_TEMPLATES: BidTemplate[] = [
  {
    key: 'banner',
    label: 'Banner 300x250',
    json: JSON.stringify(
      {
        id: 'REQ-1',
        tmax: 200,
        imp: [
          {
            id: '1',
            banner: {
              w: 300,
              h: 250,
            },
            bidfloor: 0.1,
          },
        ],
        site: {
          domain: 'example.com',
          page: 'https://example.com/article',
        },
        device: {
          ua: 'Mozilla/5.0',
          ip: '8.8.8.8',
          connectiontype: 2,
          geo: {
            country: 'USA',
          },
        },
      },
      null,
      2,
    ),
  },
  {
    key: 'native',
    label: 'Native 1.2',
    json: JSON.stringify(
      {
        id: 'REQ-2',
        tmax: 200,
        imp: [
          {
            id: '1',
            native: {
              request:
                '{"ver":"1.2","assets":[{"id":1,"required":1,"title":{"len":50}},{"id":2,"img":{"type":3,"wmin":1200,"hmin":627}}]}',
            },
            bidfloor: 0.1,
          },
        ],
        app: {
          bundle: 'com.example.app',
          storeurl: 'https://apps.example.com/app',
        },
        device: {
          ifa: '00000000-0000-0000-0000-000000000000',
          ua: 'Mozilla/5.0',
          ip: '1.1.1.1',
          connectiontype: 2,
          geo: {
            country: 'USA',
          },
        },
      },
      null,
      2,
    ),
  },
  {
    key: 'video',
    label: 'Video Instream',
    json: JSON.stringify(
      {
        id: 'REQ-3',
        tmax: 200,
        imp: [
          {
            id: '1',
            video: {
              mimes: ['video/mp4'],
              minduration: 5,
              maxduration: 30,
              w: 640,
              h: 360,
              protocols: [2, 3, 5, 6],
            },
            bidfloor: 0.1,
          },
        ],
        site: {
          domain: 'example.com',
          page: 'https://example.com/video',
        },
        device: {
          ua: 'Mozilla/5.0',
          ip: '4.4.4.4',
          connectiontype: 2,
          geo: {
            country: 'USA',
          },
        },
      },
      null,
      2,
    ),
  },
  {
    key: 'audio',
    label: 'Audio Instream',
    json: JSON.stringify(
      {
        id: 'REQ-4',
        tmax: 200,
        imp: [
          {
            id: '1',
            audio: {
              mimes: ['audio/mpeg'],
              minduration: 5,
              maxduration: 45,
              protocols: [2, 3, 5, 6],
            },
            bidfloor: 0.1,
          },
        ],
        site: { domain: 'example.com', page: 'https://example.com/podcast' },
        device: {
          ua: 'Mozilla/5.0',
          ip: '5.5.5.5',
          connectiontype: 2,
          geo: { country: 'USA' },
        },
      },
      null,
      2,
    ),
  },
]
